import { gql } from '@apollo/client'

export const GET_BY_INVITATION = gql`
  query GET_BY_INVITATION($invitationGuid: String!) {
    accounts {
      byInvitationToken(invitationId: $invitationGuid) {
        alreadyHasAccount
        invitationHasExpired
        invitationMessage
        userName
        emailAddress
        mobilePhone
        contactType
        verifyPhone
        verifyEmail
      }
    }
  }
`

export interface GetByInvitationResult {
  accounts: {
    byInvitationToken: {
      alreadyHasAccount: boolean
      invitationHasExpired: boolean
      invitationMessage: string
      userName: string
      emailAddress: string
      mobilePhone: string
      contactType: number
      verifyPhone: boolean
      verifyEmail: boolean
    }
  }
}
